import {post} from '@/plugins/axios'
import store from "@/store";

/*
 * 获取左侧菜单
 * @constructor jack
 * */

export const getMenus = (u_token) => post('/admin/getAuth', {u_token})


/**********************************通用各子系统通用接口********************************************************************/
/*
 * 获取通知列表
 * @constructor jack
 * */
export const msgList = (
  msg_title,
  page,
  list_rows,
  u_token = store.state.token2
) => post("/org/inform", {msg_title, page, list_rows, u_token});

/*
 * 通知详情
 * @constructor jack
 * */
export const msgOne = (
  msg_id,
  u_token = store.state.token2
) => post("/org/informFind", {msg_id, u_token});

/*
 * 个人信息
 * @constructor jack
 * */
export const personage = (
  u_token = store.state.token2
) => post("/org/personage", {u_token});

/*
 * 个人信息修改
 * @constructor jack
 * */
export const personageUpdate = (
  name,
  phone,
  u_token = store.state.token2
) => post("/org/personageUpdate", {name, phone, u_token});

/*
 * 密码修改
 * @constructor jack
 * */
export const personagePwd = (
  j_pass,
  pass,
  q_pass,
  u_token = store.state.token2
) => post("/org/personagePwd", {j_pass, pass, q_pass, u_token});

/*
 * 账号管理列表
 * @constructor jack
 * */
export const accountList = (
  name,
  phone,
  status,
  page,
  limit,
  u_token = store.state.token2
) => post("/org/account", {
  name,
  phone,
  status,
  page,
  limit, u_token
});

/*
 * 获取账号可选择角色列表
 * @constructor jack
 * */
export const accountRole = (u_token = store.state.token2) =>
  post("/org/getRolelist", {u_token});

/*
 * 添加账号
 * @constructor jack
 * */
export const accountAdd = (
  admin_name,
  admin_phone,
  sex,
  idcard,
  role_id,
  teach_number,
  yx_number,
  remark,
  aid,
  u_token = store.state.token2
) => post("/org/accountAdd", {
  admin_name,
  admin_phone,
  sex,
  idcard,
  role_id,
  teach_number,
  yx_number,
  remark,
  aid,
  u_token
});
/*
 * 编辑账号
 * @constructor jack
 * */
export const accountUpdate = (
  admin_name,
  admin_phone,
  sex,
  idcard,
  role_id,
  remark,
  aid,
  u_token = store.state.token2
) => post("/org/accountUpdate", {
  admin_name,
  admin_phone,
  sex,
  idcard,
  role_id,
  remark,
  aid, u_token
});
/*
 * 帐号删除
 * @constructor jack
 * */
export const accountDel = (admin_id, u_token = store.state.token2) =>
  post("/item/userDel", {admin_id, u_token});

/*
 * 帐号停用/启用
 * @constructor jack
 * */
export const accountState = (aid, status, u_token = store.state.token2) =>
  post("/org/accountState", {aid, status, u_token});

/*
 * 帐号密码初始化
 * @constructor jack
 * */
export const accountPwd = (aid, u_token = store.state.token2) =>
  post("/org/accountPwd", {aid, u_token});

/*
 * 机构详情
 * @constructor jack
 * */
export const orgFind = ( u_token = store.state.token2) =>
  post("/org/orgFind", { u_token});

/*
 * 机构详情更新
 * @constructor jack
 * */
export const orgUpdate = (
  org_name,
  org_num,
  org_code,
  org_license,
  region_id,
  region_text,
  address,
  username,
  phone,
  email,
  bear_num,
  remark,
  longitude,
  latitude,
  u_token = store.state.token2
) => post("/org/orgUpdate", {
  org_name,
  org_num,
  org_code,
  org_license,
  region_id,
  region_text,
  address,
  username,
  phone,
  email,
  bear_num,
  remark,
  longitude,
  latitude,
  u_token
});